import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import TopNav from '@componentes/nav/nav.component';
import MenuComponent from '@componentes/menu/menu.component';
import FadeComponent from '@componentes/fade/fade.component';
import NotificacaoComponent from '@componentes/notificacao/notificacao.component';
import DefaultDataItens from '@componentes/DefaultDataItens';
import { useIntl } from 'react-intl';

function Layout ({ children }) {
  const intl = useIntl();
  const history = useHistory();
  const carregando = useSelector(state => state.commonReducer.showCarregando);
  const modal = useSelector(state => state.commonReducer.showModal);
  const mensagemAlerta = useSelector(state => state.commonReducer);
  const { mensagem, timeout, tipoAlerta, idAlerta, minWidth } = mensagemAlerta;

  return (
    <div>
      <div className={`menu-fade ${modal ? 'open' : 'close'}`}></div>
      <FadeComponent visible={carregando} />
      <TopNav history={history} />
      <MenuComponent history={history} intl={intl} />

      {children}

      <NotificacaoComponent
        mensagem={mensagem}
        timeout={timeout}
        tipo={tipoAlerta}
        id={idAlerta}
        minWidth={minWidth}
      />
      <DefaultDataItens />
    </div>
  );
}

export default Layout;



// WEBPACK FOOTER //
// ./src/componentes/Layout/index.js